module.exports = __webpack_public_path__ + "img/Mallas.5580a4c0.jpg";